import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { PublicPlanItem } from './useGetPublicPlans';

export const useGetUpgradePlans = (enabled = true) => {
	return useQuery({
		queryKey: ['upgrade-plans'],
		queryFn: async () => {
			const { data } = await api.get('/landing/plan/findUpgradePlan');
			return data as PublicPlanItem[];
		},
		enabled,
	});
};
